// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r2-6";
export var imgContainer = "_r2-3";
export var menuIcon = "_r2-5";
export var pillWrapper = "_r2-2";
export var pillsContainer = "_r2-1";
export var subscriptionCard = "_r2-0";
export var subscriptionLogo = "_r2-4";